import _ from "lodash";
export const getFilteredModules = (state, getters) => (opleiding, filter, sortby) => {
  let moduleList = state.moduleList

  let gevolgdemoduleList = state.gevolgdeopleidingOpleidingList
  let currentOpleiding = state.currentOpleiding

  return _.orderBy(updatecurrentAllModules(currentOpleiding), sortby[0], sortby[1]);


  function updatecurrentAllModules(currentOpleiding) {
    let a = moduleList.filter(function (value) {
      return value.OpleidingsvariantID === currentOpleiding.OpleidingsvariantID;
    });
    let filtergelvolgdeopleiding = gevolgdemoduleList.filter(function (value) {
      return value.OpleidingsvariantID === currentOpleiding.OpleidingsvariantID;
    });
    let combinedModules = a.concat(filtergelvolgdeopleiding);
    //'Geslaagd', 'Niet Geslaagd','Aan het volgen','Nog Niet gevolgd'
    if (filter === 'Geslaagd of vrijgesteld') {
      return combinedModules.filter(e => e.Resultaat === "GESLAAGD" || e.Atype === 'VRIJSTELLING');
    } else if (filter === 'Niet geslaagd') {
      return combinedModules.filter(e => e.Resultaat === "NT_GESLAAGD" || e.Resultaat === "NT_GESLAAGD" || e.Resultaat === "NT_DEELGENOMEN");
    } else if (filter === 'Aan het volgen') {
      return combinedModules.filter(e => e.Resultaat === "?");
    } else if (filter === 'Nog niet gevolgd') {
      return filtergelvolgdeopleiding
    } else {
      return combinedModules
    }
  }

};